import React ,{ useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getOnePartner, updatePartner } from '../redux/apiCalls/accidentApiCall';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { Oval } from 'react-loader-spinner';
function InfosPartnerEdite() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {getLoading} = useSelector(state => state.accident)
      const [userData, setUserData] = useState({
      });
      const { id } = useParams();
      const partner = useSelector((state) => state.accident.partner);
      useEffect(() => {
        if (id) {
          dispatch(getOnePartner(id));
        }
      }, [dispatch, id]);
    
      useEffect(() => {
        if (partner) {
          setUserData({
            name: partner.user.name || null,
            email: partner.user.email || "",
            address: partner.user.address || null,
            city: partner.user.city || null,
            phoneNumber: partner.user.phoneNumber || null,
            description: partner.user.description || null,
            iban: partner.user.iban || null,
            accountInfo: partner.user.accountInfo || null,
            username: partner.user.username || "",
            profilePhoto: partner.user.profilePhoto?.url || null
          });
        }
      }, [partner]);
      const handleChange = (e) => {
        const { name, value } = e.target;
        setUserData((prev) => ({ ...prev, [name]: value }));
      };
      const handleSubmit = (e) => {
        e.preventDefault();
      
        // إنشاء FormData
        const formData = new FormData();
      
        // إضافة الحقول النصية
        formData.append("email", userData.email);
        formData.append("username", userData.username);
        formData.append("password", userData.password);
        formData.append("name", userData.name);
        formData.append("address", userData.address);
        formData.append("city", userData.city);
        formData.append("iban", userData.iban);
        formData.append("accountInfo", userData.accountInfo);
        formData.append("phoneNumber", userData.phoneNumber);
        formData.append("description", userData.description);
      
        // إضافة الصورة (إذا كانت موجودة)
        if (userData.profilePhoto instanceof File) {
          formData.append("image", userData.profilePhoto); // اسم الحقل يجب أن يكون "image"
        }
      
        // إرسال الطلب باستخدام Redux أو Axios
        dispatch(updatePartner(id, formData,navigate)); // تأكد من أن `updatePartner` معد لقبول formData
        for (let pair of formData.entries()) {
          console.log(pair[0], pair[1]);
        }
      };

      if(getLoading){
        return <div>loading</div>
      }
      console.log(userData);
      
      return(
      <div className='flex flex-col w-[100%] h-screen overflow-y-auto hidden-scrollbar'>
      <div className="bg-gray-100 min-h-screen p-8">
<form className=" p-6 rounded-lg flex flex-col">
  <div className="">
    <div className="flex w-[100%] items-center pb-[10px]">
      <label className="font-[700] w-[25%]">Name</label>
      <input
        type="text"
        name="name"
        value={userData?.name}
        onChange={handleChange}
        className="w-full border border-gray-300 bg-[#c8e8ef] rounded-[18px] pt-[5px] pl-[10px] pr-[10px] pb-[5px] focus:outline-none"
      />
    </div>
    <div className="flex w-[100%] items-center pt-[10px] pb-[10px]">
      <label className="font-[700] w-[25%]">Adresse</label>
      <input
        type="text"
        name="address"
        value={userData?.address}
        onChange={handleChange}
        className="w-full border border-gray-300 bg-[#c8e8ef] rounded-[18px] pt-[5px] pl-[10px] pr-[10px] pb-[5px] focus:outline-none"
      />
    </div>
    <div className="flex w-[100%] items-center pt-[10px] pb-[10px]">
      <label className="font-[700] w-[25%]">Ort:</label>
      <input
        type="text"
        name='city'
        value={userData?.city}
        onChange={handleChange}
        className="w-full border border-gray-300 bg-[#c8e8ef] rounded-[18px] pt-[5px] pl-[10px] pr-[10px] pb-[5px] focus:outline-none placeholder:text-center placeholder:font-[500]"
        placeholder='Bauteil'
      />
    </div>
    <div className="flex w-[100%] items-center pt-[10px] pb-[10px]">
      <label className="font-[700] w-[25%]">IBAN</label>
      <input
        type="text"
        name='iban'
        value={userData?.iban}
        onChange={handleChange}
        className="w-full border border-gray-300 bg-[#c8e8ef] rounded-[18px] pt-[5px] pl-[10px] pr-[10px] pb-[5px] focus:outline-none placeholder:text-center placeholder:font-[500]"
        placeholder='Bauteil'
      />
    </div>
    <div className="flex w-[100%] items-center pt-[10px] pb-[10px]">
      <label className="font-[700] w-[25%]">Bankdaten</label>
      <input
        type="text"
        name='accountInfo'
        value={userData?.accountInfo}
        onChange={handleChange}
        className="w-full border border-gray-300 bg-[#c8e8ef] rounded-[18px] pt-[5px] pl-[10px] pr-[10px] pb-[5px] focus:outline-none placeholder:text-center placeholder:font-[500]"
        placeholder='Nur Ort'
      />
    </div>
    <div className="flex w-[100%] items-center pt-[10px] pb-[10px]">
      <label className="font-[700] w-[25%]">Benutzername</label>
      <input
        type="text"
        name='username'
        value={userData?.username}
        onChange={handleChange}
        className="w-full border border-gray-300 bg-[#c8e8ef] rounded-[18px] pt-[5px] pl-[10px] pr-[10px] pb-[5px] focus:outline-none placeholder:text-center placeholder:font-[500]"
        placeholder='geparkt, vorfahrt etc.'
      />
    </div>
    <div className="flex w-[100%] items-center pt-[10px] pb-[10px]">
      <label className="font-[700] w-[25%]">Passwort</label>
      <input
        type="text"
        name='password'
        onChange={handleChange}
        value={userData?.password}
        className="w-full border border-gray-300 bg-[#c8e8ef] rounded-[18px] pt-[5px] pl-[10px] pr-[10px] pb-[5px] focus:outline-none placeholder:text-center placeholder:font-[500]"
        placeholder=''
      />
    </div>
    <div className="flex w-[100%] items-center pt-[10px] pb-[10px]">
      <label className="font-[700] w-[25%]">Telefonnummer</label>
      <input
        type="text"
        name='phoneNumber'
        value={userData?.phoneNumber}
        onChange={handleChange}
        className="w-full border border-gray-300 bg-[#c8e8ef] rounded-[18px] pt-[5px] pl-[10px] pr-[10px] pb-[5px] focus:outline-none placeholder:text-center placeholder:font-[500]"
        placeholder='PLZ, Screenshot Maps O.Ä.'
      />
    </div>
    <div className="flex w-[100%] items-center pt-[10px] pb-[10px]">
      <label className="font-[700] w-[25%]">Email-Adresse</label>
      <input
      name='email'
        type="text"
        value={userData?.email}
        onChange={handleChange}
        className="w-full border border-gray-300 bg-[#c8e8ef] rounded-[18px] pt-[5px] pl-[10px] pr-[10px] pb-[5px] focus:outline-none placeholder:text-center placeholder:font-[500]"
        placeholder='Inhaber und IBAN'
      />
    </div>
    <div className="flex w-[100%] items-center pt-[10px] pb-[10px]">
  <label className="font-[700] w-[25%]">Profile Photo</label>
  <input
    type="file"
    name="profilePhoto"
    onChange={(e) => {
        const file = e.target.files[0];
        if (file) {
          setUserData((prev) => ({
            ...prev,
            profilePhoto: file, // قم بتخزين ملف الصورة مباشرة
          }));
        }
      }}
    className="w-full border border-gray-300 bg-[#c8e8ef] rounded-[18px] pt-[5px] pl-[10px] pr-[10px] pb-[5px] focus:outline-none"
  />
</div>
{userData?.profilePhoto && (
  <div className="flex justify-center pb-[10px]">
    <img
  src={userData.profilePhoto instanceof File ? URL.createObjectURL(userData.profilePhoto) : userData.profilePhoto}
  alt="User Profile"
  className="w-32 h-32 border border-gray-300 rounded-full object-cover"
/>

  </div>
)}

  </div>

  <div className="flex pb-[10px]">
    <label className="font-[700] w-[25%]">
    Bemerkungen
    </label>
    <textarea
    name="description" 
              value={userData?.description}
              onChange={handleChange}
      className="w-full resize-none rounded-[19px] p-2 focus:outline-none border border-gray-300 bg-[#c8e8ef]"
      rows="3"
    ></textarea>
  </div>
</form>
<div className="flex justify-center pt-[10px] pb-[50px]">
{!getLoading?<button
  type="submit"
  onClick={handleSubmit}
  className="mt-4 flex justify-center items-center text-center bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600"
>
  Update 
</button>:<button
  type="submit"
  className="mt-4 flex justify-center items-center text-center bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600"
>
  <Oval
  visible={true}
  height="20"
  width="20"
  color="#fff"
  ariaLabel="oval-loading"
  wrapperStyle={{}}
  wrapperClass=""
  />
</button>}
</div>
</div>
  </div>
  )
}

export default InfosPartnerEdite
